// extracted by mini-css-extract-plugin
export default {"departments":"HM-z","departmentHeading":"IM-z","departmentSection":"JM-z","departmentName":"KM-z","departmentLink":"LM-z","expandIcon":"MM-z"};